import { avatarColor, avatarInitials } from "../lib/avatar";

interface AvatarProps {
  name: string;
  size?: "sm" | "md";
}

// Reusable deterministic-color avatar. sm = 32px (table), md = 40px (drawer header).
export function Avatar({ name, size = "sm" }: AvatarProps) {
  const dim = size === "sm" ? 32 : 40;
  const fontSize = size === "sm" ? 12 : 14;
  return (
    <div
      className="flex flex-none items-center justify-center rounded-pill font-bold text-white"
      style={{
        width: dim,
        height: dim,
        fontSize,
        background: avatarColor(name),
      }}
    >
      {avatarInitials(name)}
    </div>
  );
}
